import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faDownload, faBook } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'

export default function CVMenu({ enabled }) {
    const [showMenu, setShowMenu] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [mounted, setMounted] = useState(false);

    // S'assurer que le composant est monté côté client
    useEffect(() => {
        setMounted(true);
    }, []);

    // Fermer le menu en cliquant ailleurs
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showMenu && !event.target.closest('.cv-menu-container') && !event.target.closest('.cv-menu-portal')) {
                setShowMenu(false);
            }
        };

        if (showMenu) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showMenu]);

    const downloadCV = (language) => {
        if (language === 'fr') {
            window.open('/cv/Francais.pdf', '_blank');
        }
        setShowMenu(false);
    };

    // Menu simple avec boutons directs - pas de portail compliqué
    return (
        <>
            {showModal && mounted && createPortal(
                <div className={`fixed inset-0 z-[100] flex items-center justify-center ${enabled ? 'bg-black bg-opacity-80' : 'bg-black bg-opacity-50'} backdrop-blur-sm`}>
                    <div className={`rounded-2xl shadow-2xl p-7 w-full max-w-xs sm:max-w-sm border relative animate-fade-in
                        ${enabled ? 'bg-[#0c0c0f] border-gray-800 text-white' : 'bg-white border-gray-200 text-gray-800'}`}
                    >
                        <button onClick={() => setShowModal(false)} className={`absolute top-3 right-3 text-gray-400 hover:text-gray-600 ${enabled ? 'hover:text-white' : ''} text-xl focus:outline-none`}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                        <div className="flex items-center gap-2 mb-6">
                            <FontAwesomeIcon icon={faDownload} className="text-orange-500 text-lg" />
                            <span className={`font-semibold text-lg ${enabled ? 'text-white' : 'text-gray-800'}`}>Téléchargement du CV</span>
                        </div>
                        <button onClick={() => {window.open('/cv/Francais.pdf', '_blank'); setShowModal(false);}} className={`w-full text-left px-4 py-3 text-base flex items-center rounded-lg transition-all duration-150 mb-3 shadow-sm
                            ${enabled ? 'bg-[#090911FF]/40 text-white hover:bg-orange-400/10' : 'hover:bg-orange-50 text-gray-700'}`}
                        >
                            <FontAwesomeIcon icon={faBook} className="mr-3 text-orange-500" />
                            <span className="flex-1 font-medium">Version Française</span>
                            <FontAwesomeIcon icon={faDownload} className="text-orange-500 text-xs" />
                        </button>
                        <button className={`w-full text-left px-4 py-3 text-base flex items-center rounded-lg cursor-not-allowed opacity-60
                            ${enabled ? 'bg-[#090911FF]/20 text-gray-400' : 'bg-gray-100 text-gray-400'}`}
                            disabled>
                            <FontAwesomeIcon icon={faBook} className="mr-3 text-gray-400" />
                            <span className="flex-1">Version Anglaise</span>
                            <span className="text-xs bg-gray-200 text-gray-500 px-2 py-1 rounded-full">Bientôt</span>
                        </button>
                    </div>
                </div>, document.body
            )}
            <div className="cv-menu-container inline-block">
                <button
                    onClick={() => setShowModal(true)}
                    className="pulse-button mr-4 download hover:bg-[#191932]/30 shadow-lg hover:shadow-xl transition-all duration-200 rounded-lg p-3 transform hover:scale-105 active:scale-95"
                >
                    <p className="text-md text-black flex items-center">
                        <FontAwesomeIcon icon={faDownload} className="mr-2" /> Mon CV
                    </p>
                </button>
                {showMenu && (
                    <div className="inline-flex flex-col bg-white border border-gray-200 rounded-lg shadow-xl mt-2">
                        <div className="px-3 py-2 text-xs font-semibold border-b text-gray-500 border-gray-200 flex items-center">
                            <FontAwesomeIcon icon={faDownload} className="mr-2" />
                            Télécharger mon CV
                            <button 
                                onClick={() => setShowMenu(false)}
                                className="ml-auto text-gray-400 hover:text-gray-600"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <button
                            onClick={() => downloadCV('fr')}
                            className="w-full text-left px-3 py-3 text-sm flex items-center hover:bg-gray-100 transition-all duration-150 text-gray-700"
                        >
                            <FontAwesomeIcon icon={faBook} className="mr-3 text-orange-500" />
                            <span className="flex-1 font-medium">Version Française</span>
                            <FontAwesomeIcon icon={faDownload} className="text-orange-500 text-xs" />
                        </button>
                        <button
                            className="w-full text-left px-3 py-3 text-sm flex items-center text-gray-400 cursor-not-allowed opacity-60"
                            disabled
                        >
                            <FontAwesomeIcon icon={faBook} className="mr-3 text-gray-400" />
                            <span className="flex-1">Version Anglaise</span>
                            <span className="text-xs bg-gray-200 text-gray-500 px-2 py-1 rounded-full">Bientôt</span>
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}